import { render, staticRenderFns } from "./MomentItemFeed.vue?vue&type=template&id=77717a5a&scoped=true&"
import script from "./MomentItemFeed.vue?vue&type=script&lang=js&"
export * from "./MomentItemFeed.vue?vue&type=script&lang=js&"
import style0 from "./MomentItemFeed.vue?vue&type=style&index=0&id=77717a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77717a5a",
  null
  
)

export default component.exports